Webfont = require('webfontloader')


fontsLoaded = false
fontsErrored = false

bootstrapIfLoaded = () ->
  if windowLoaded && (fontsLoaded || fontsErrored)
    angular.bootstrap(document.getElementById('ng-app'), ['workflow.app'])

Webfont.load({
  custom: {
# Font URLs are taken from CSS
    families: [
      'Glyphicons Halflings',
      'Glyphicons Regular',
      'Roboto:n4,n7',
      'ui-grid'
    ]
    testStrings: {
      'Glyphicons Regular': '\uE004', # User
      'Glyphicons Halflings': '\ue081' # Plus sign
    }
  }
  timeout: 5000
  active: () ->
    fontsLoaded = true
    bootstrapIfLoaded()

  inactive: () ->
    fontsErrored = true
    bootstrapIfLoaded()
})

windowLoaded = false
angular.element(window).on('load', () ->
  windowLoaded = true
  bootstrapIfLoaded()
)

